import React, { FC } from 'react';
import { Alert, AlertPropsType } from '@clearcover/atlas';
import disclaimers from 'Shared/locales/purchase/disclaimers.json';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

export const PaymentDisclaimer: FC<{ variant: AlertPropsType['type'] }> = ({
  variant,
}) => {
  const { details } = useAppContext();
  const state = details.address[details.principalInsuredId].state.value;

  const paymentDisclaimer = (state: keyof typeof disclaimers) =>
    state in disclaimers ? disclaimers[state] : disclaimers.default;

  return (
    <Alert
      type={variant}
      className={styles.paymentDisclaimer}
      message={paymentDisclaimer(state as keyof typeof disclaimers)}
    />
  );
};
